import { supportsTouchEvents } from 'detect-it';

const nodeOnTouch = {
  methods: {
    onTouch(event) {
      if (event.pointerType === 'touch') {
        console.log('--- node on touch:', event);
        if (event.type === 'singletap') {
          console.log('*******NODE TAP', event);
          if (this.onMouseUp) {
            this.onMouseUp(event);
          }
        } else if (event.type === 'doubletap') {
          console.log('*******NODE DOUBLE TAP', event);
          if (this.onDblClick) {
            this.onDblClick(event);
          }
        } else if (event.type === 'press' && supportsTouchEvents) {
          console.log('*******NODE PRESS', event);
          if (this.onContextMenu) {
            this.onContextMenu(event);
          }
        } else if (event.type === 'pan') {
          console.log('*******NODE PAN', event);
        }
      }
      event.stopPropagation();
    },
  },
};

export default nodeOnTouch;
